@for(topico of ServicoExibido?.listaTopicos; track $index){
  <h5 style="font-weight: 600; padding-top: 1rem;">{{topico.titulo}}</h5>
  <hr style="color: var(--tom-2-informativo); background-color: var(--tom-2-informativo); height: 4px; opacity: 1;">
  @for(descricao of topico?.descricoes; track $index){
    @if(descricao.linkURL){
      <a [href]="descricao.linkURL" target="_blank" rel="noopener noreferrer">{{descricao.texto}}</a>
    } @else if (descricao.arquivo) {
      <span
        class="link-download"
        tabindex="0"
        (click)="baixarArquivoSelecionado(descricao.arquivo)" 
        (keyup.enter)="baixarArquivoSelecionado(descricao.arquivo)">{{descricao.texto}}</span>
    } @else {
      <span [innerHTML]="descricao.texto | safeHtml"></span>
    }

    @if(!descricao.naoPularLinha){
      <br><br>
    }
  }
  @if(topico?.subTopicos && topico?.subTopicos.length > 0){
    @if(ServicoExibido?.listaTopicosArquivos?.length > 0){
      <div style="text-align: right;">
        <span style="text-decoration: underline; color: var(--tom-2-informativo); cursor: pointer; text-align: right; width: fit-content;"
          tabindex="0" (click)="abrirAccordionsSecaoEDownload(topico, ServicoExibido?.listaTopicosArquivos[0])"
          (keyup.enter)="abrirAccordionsSecaoEDownload(topico, ServicoExibido?.listaTopicosArquivos[0])">Ver todos
        </span>
      </div>
    } @else {
       <div style="text-align: right;">
        <span style="text-decoration: underline; color: var(--tom-2-informativo); cursor: pointer; width: fit-content; text-align: right;"
      tabindex="0" (click)="abrirAccordionsSecao(topico)" (keyup.enter)="abrirAccordionsSecao(topico)">Ver todos</span>
       </div>
    }
  }
  @for(sub of topico?.subTopicos; track $index){
    <lib-segov-sigepo-accordeon
      [id]="'sub-topico-'+$index"
      [customTitleStyle]="'padding-left: 1rem; font-weight: 600; font-size: 18px;'"
      [customChevronStyle]="'font-size: 20px; color: var(--tom-2-informativo);'"
      [title]="sub.titulo"
      [isExpanded]="topico.exibirTodosAccordions || navigateFragment === 'sub-topico-'+$index">
      @for(descricao of sub?.descricoes; track $index){
        @if(descricao.linkURL){
          <a [href]="descricao.linkURL" target="_blank" rel="noopener noreferrer" (click)="$event.stopPropagation()">{{descricao.texto}}</a>
        } @else if (descricao.arquivo) {
          <span
            class="link-download"
            tabindex="0"
            (click)="baixarArquivoSelecionado(descricao.arquivo); $event.stopPropagation()" 
            (keyup.enter)="baixarArquivoSelecionado(descricao.arquivo); $event.stopPropagation()">{{descricao.texto}}</span>
        } @else {
          <span [innerHTML]="descricao.texto | safeHtml"></span>
        }

        @if(!descricao.naoPularLinha){
          <br><br>
        }
      }
    </lib-segov-sigepo-accordeon>
  }
}

@for(agrupamento of ServicoExibido?.listaTopicosArquivos; track $index) {
  @if(agrupamento.titulo){
    <h5 style="font-weight: 600; padding-top: 1rem;">{{agrupamento.titulo}}</h5>
    <hr style="color: var(--tom-2-informativo); background-color: var(--tom-2-informativo); height: 4px; opacity: 1;">
  }

  @if(obterLengthDict(agrupamento) > 1) {
    <div style="text-align: right;">
      <span style="text-decoration: underline; color: var(--tom-2-informativo); cursor: pointer; width: fit-content; text-align: right;"
      tabindex="0" (click)="abrirAccordionsSecao(agrupamento)" (keyup.enter)="abrirAccordionsSecao(agrupamento)">Ver todos downloads</span>
    </div>
  }

  @if(!agrupamento.incluirDescricaoNoAccordeon) {
    @for(descricao of agrupamento?.descricoes; track $index){
      @if(descricao.linkURL){
        <a [href]="descricao.linkURL" target="_blank" rel="noopener noreferrer">{{descricao.texto}}</a>
      } @else if (descricao.arquivo) {
        <span
          class="link-download"
          tabindex="0"
          (click)="baixarArquivoSelecionado(descricao.arquivo)" 
          (keyup.enter)="baixarArquivoSelecionado(descricao.arquivo)">{{descricao.texto}}</span>
      } @else {
        <span [innerHTML]="descricao.texto | safeHtml"></span>
      }
      @if(!descricao.naoPularLinha){
        <br><br>
      }
    }
  }
  @for (arquivos of agrupamento.listaNomeArquivos | dictReverseOrder; track arquivos.key) {
    <lib-segov-sigepo-accordeon
      [customTitleStyle]="'padding-left: 1rem; font-weight: 600; font-size: 20px;'"
      [customChevronStyle]="'font-size: 20px; color: var(--tom-2-informativo);'"
      [title]="arquivos.key"
      [isExpanded]="agrupamento.exibirTodosAccordions">
      @for(arquivo of arquivos.value; track $index) {
        @if($index === 0 && agrupamento.incluirDescricaoNoAccordeon){
          @for(descricao of agrupamento?.descricoes; track $index){
            @if(descricao.linkURL){
              <a [href]="descricao.linkURL" target="_blank" rel="noopener noreferrer" (click)="$event.stopPropagation()">{{descricao.texto}}</a>
            } @else if (descricao.arquivo) {
              <span
                class="link-download"
                tabindex="0"
                (click)="baixarArquivoSelecionado(descricao.arquivo); $event.stopPropagation()" 
                (keyup.enter)="baixarArquivoSelecionado(descricao.arquivo); $event.stopPropagation()">{{descricao.texto}}</span>
            }  @else {
              <span [innerHTML]="descricao.texto | safeHtml"></span>
            }
            @if(!descricao.naoPularLinha){
              <br><br>
            }
          }
        }
        <p>
          <img src="icons/download-arrow-line.svg"
          alt="Ícone download"
          style="cursor: pointer;"
          width="24px"
          tabindex="0"
          (click)="baixarArquivoSelecionado(arquivo); $event.stopPropagation()"
          (keyup.enter)="baixarArquivoSelecionado(arquivo); $event.stopPropagation()"/>{{arquivo?.dataPublicacao | date: 'dd/MM/yyyy'}} {{arquivo?.dataPublicacao ? '-' : ' '}} {{arquivo?.titulo}}
        </p>
      }
    </lib-segov-sigepo-accordeon>
  }

}

